import { useRef, useState } from "react";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fileUrl } from "@/lib/api";
import { STATUS_LABEL } from "@/lib/content";

export function AdminTitle({ title, children }) {
  return (
    <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
      <h1 className="font-display text-3xl font-bold uppercase text-ink sm:text-4xl">{title}</h1>
      <div className="flex flex-wrap gap-2">{children}</div>
    </div>
  );
}

const STATUS_CLS = { nouveau: "bg-asso text-white", en_cours: "bg-gold text-ink", traite: "bg-ong text-white" };
export function StatusBadge({ status }) {
  return <span className={`rounded-full px-2.5 py-0.5 text-xs font-semibold ${STATUS_CLS[status]}`}>{STATUS_LABEL[status]}</span>;
}

export function StatusSelect({ value, onChange, testid }) {
  return (
    <select className="input !w-auto !py-1.5 text-sm" value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid}>
      {Object.entries(STATUS_LABEL).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
    </select>
  );
}

export function UploadField({ value, onChange, accept, testid }) {
  const ref = useRef();
  const [loading, setLoading] = useState(false);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd);
      onChange(data.url);
      toast.success("Fichier envoyé");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
      e.target.value = "";
    }
  };
  const isImg = value && /\.(webp|png|jpe?g|gif)$/i.test(value);
  return (
    <div className="space-y-2">
      <div className="flex gap-2">
        <input className="input" placeholder="URL (ou envoyer un fichier)" value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={`${testid}-url`} />
        <button type="button" className="btn-u !px-4 !py-2" onClick={() => ref.current.click()} disabled={loading} data-testid={`${testid}-upload`}>
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />}
        </button>
        <input ref={ref} type="file" accept={accept} className="hidden" onChange={pick} data-testid={`${testid}-file`} />
      </div>
      {isImg && <img src={fileUrl(value)} alt="" className="h-24 rounded border object-cover" />}
    </div>
  );
}
